import axios from "axios";
import React, { useEffect, useState } from "react";
import {
  Modal,
  Button,
  Image,
  Form,
  CloseButton,
  Badge,
} from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { addProduct } from "../../app/features/cart/cartSlice";
import Swal from "sweetalert2";
import { useDispatch } from "react-redux";
const getAuthToken = () => {
  const userData = sessionStorage.getItem("userData");
  if (!userData) return "";
  try {
    const parsed = JSON.parse(userData);
    return parsed.token || "";
  } catch {
    return "";
  }
};

if (typeof document !== "undefined") {
  const styleId = "slide-right-cart-style";
  if (!document.getElementById(styleId)) {
    const style = document.createElement("style");
    style.id = styleId;
    style.innerHTML = `
       .modal.fade .modal-dialog.slide-right {
        transform: translateX(100%);
        transition: transform 0.3s ease-out;
      }
      .modal.show .modal-dialog.slide-right {
        transform: translateX(0);
      }
      .modal.slide-right-modal .modal-dialog {
        position: fixed;
        right: 0;
        top: 0;
        margin: 0;
        height: 100%;
        max-width: 700px;
        width: 100%;
      }
      .modal.slide-right-modal .modal-content {
        height: 100%;
        border-radius: 0;
        border: none;
        overflow-y: auto;
      }
      .hide-scrollbar::-webkit-scrollbar {
        display: none;
      }
      .hide-scrollbar {
        -ms-overflow-style: none;
        scrollbar-width: none;
      }
      @media (max-width: 767px) {
        .modal.slide-right-modal .modal-dialog {
          width: 95% !important;
          margin-left: auto;
          margin-right: 0;
        }
          
          .quick-view-qty-btn {
  width: 40px;
  height: 100%;
  font-size: 18px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  padding: 0;
  cursor: pointer;
  font-weight: bold;
  border: none;
  color: inherit; /* or set a specific color */
  transition: background-color 0.2s ease;
}

.quick-view-qty-btn:hover {
  background-color: #f0f0f0; /* subtle hover background */
  color: #333 !important;    /* ensures symbol stays dark/visible */
}

.quick-view-qty-btn:focus {
  outline: none;
  box-shadow: none;
}
      }
    `;
    document.head.appendChild(style);
  }
}

const ProductQuickViewModal = ({ show, onHide, product, productId }) => {
  const [selectedColor, setSelectedColor] = useState("Gray");
  const [selectedSize, setSelectedSize] = useState("L");
  const [quantity, setQuantity] = useState(1);
  const [productDetails, setProductDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [randomProducts, setRandomProducts] = useState([]);

  useEffect(() => {
    axios
      .get("https://vantara.datacubeglobal.com/api/random_products")
      .then((response) => {
        if (response.data.status === "success") {
          const mapped = response.data.data.map((p) => {
            let displayPrice = 0;
            switch (p.primary_price) {
              case "mrp":
                displayPrice = parseFloat(p.mrp);
                break;
              case "special_price":
                displayPrice = parseFloat(p.special_price);
                break;
              case "retail":
                displayPrice = parseFloat(p.retail);
                break;
              case "wholesale":
                displayPrice = parseFloat(p.wholesale);
                break;
              default:
                displayPrice = parseFloat(p.mrp);
            }

            return {
              id: p.product_id,
              title: p.product_name,
              price: p.special_price,
              oldPrice:
                parseFloat(p.special_price) > 0 &&
                  parseFloat(p.special_price) < parseFloat(p.mrp)
                  ? `₹${parseFloat(p.mrp).toFixed(2)}`
                  : null,
              discount:
                parseFloat(p.special_price) > 0 &&
                  parseFloat(p.special_price) < parseFloat(p.mrp)
                  ? `-${Math.round(((p.mrp - p.special_price) / p.mrp) * 100)}%`
                  : null,
              img: `https:\/\/vantara.datacubeglobal.com\/storage/${p.primary_image}`,
            };
          });
          setRandomProducts(mapped);
        }
      })
      .catch((error) =>
        console.error("Error fetching random products:", error)
      );
  }, []);




  useEffect(() => {
    if (!productId || !show) return;

    const fetchProduct = async () => {
      setLoading(true);
      try {
        const res = await axios.get(
          `https://vantara.datacubeglobal.com/api/api-products/${productId}`
        );
        console.log("API Response:", res.data);

        let productData;

        // Handle both cases
        if (Array.isArray(res.data)) {
          productData = res.data[0];
        } else if (res.data?.status === "success" && res.data.data) {
          productData = Array.isArray(res.data.data)
            ? res.data.data[0]
            : res.data.data;
        }

        if (productData) {
          setProductDetails(productData);
          console.log("Fetched productDetails:", productData); // ✅ This will now log
        }
      } catch (err) {
        console.error("Error fetching product details:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchProduct();
  }, [productId, show]);

  const getDisplayPrice = (p) => {
    if (!p) return 0;
    return parseFloat(p.special_price) || parseFloat(p.mrp) || 0;
  };

  const displayPrice = getDisplayPrice(productDetails);

  // ✅ Prepare product images for carousel
  const productImages = productDetails
    ? [
      `${productDetails.image_path}/${productDetails.primary_image}`,
      ...(productDetails.images || [])
        .filter((img) => img !== productDetails.primary_image)
        .map((img) => `${productDetails.image_path}/${img}`),
    ]
    : [];

  useEffect(() => {
    if (show && window.innerWidth >= 768) {
      document.body.classList.add("hide-scrollbar");
      document.body.style.overflow = "hidden";
    } else {
      document.body.classList.remove("hide-scrollbar");
      document.body.style.overflow = "";
    }
    return () => {
      document.body.classList.remove("hide-scrollbar");
      document.body.style.overflow = "";
    };
  }, [show]);

  const handleAddToCart = async (productDetails, productId) => {
    const token = getAuthToken();

    // if no token → show login modal
    if (!token) {
      // setShowLoginModal(true);
      return;
    }

    try {
      const res = await axios.post(
        "https://vantara.datacubeglobal.com/api/cart",
        {
          product_id: productDetails?.id || productDetails?.product_id,
          quantity: quantity,
          options: "",
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (res.data.status === "success") {
        dispatch(addProduct({ ...product, quantity }));

        Swal.fire({
          toast: true,
          icon: "success",
          title: "Added to Cart successfully",
          position: "top-end",
          showConfirmButton: false,
          timer: 1000,
          timerProgressBar: true,
        }).then(() => {
          // Open QuickViewModal after toast
          // setShowQuickViewModal(true);
        });
      } else {
        Swal.fire({
          toast: true,
          icon: "info",
          title: res.data.message || "Unable to add to cart",
          position: "top-end",
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
        });
      }
    } catch (error) {
      console.error("Error adding to cart:", error);
      Swal.fire({
        toast: true,
        icon: "error",
        title: "Something went wrong!",
        position: "top-end",
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
      });
    }
  };



  const colors = [
    { name: "Beige", hex: "#d2b48c" },
    { name: "Black", hex: "#000000" },
    { name: "Gray", hex: "#808080" },
  ];
  const sizes = ["S", "M", "L", "XL", "XXL"];

  const incrementQuantity = () => setQuantity((q) => q + 1);
  const decrementQuantity = () => setQuantity((q) => Math.max(1, q - 1));

  const displayProduct = productDetails || product;
  return (
    <Modal
      show={show}
      onHide={onHide}
      className="slide-right-modal fade"
      dialogClassName="slide-right"
      backdrop={true}
      keyboard={true}
    >
      <Modal.Header className="border-bottom px-4 pt-4 pb-3">
        <Modal.Title className="h5 mb-0">Quick View</Modal.Title>
        <CloseButton onClick={onHide} />
      </Modal.Header>

      <Modal.Body className="p-0" style={{ height: "100%" }}>
        <div
          className="d-flex flex-column flex-md-row"
          style={{ height: "100%" }}
        >
          {/* LEFT COLUMN - You May Also Like */}
          <div
            className="hide-scrollbar d-none d-md-block"
            style={{
              width: "100%",
              maxWidth: "200px",
              padding: "1rem",
              overflowY: "auto",
              WebkitOverflowScrolling: "touch",
            }}
          >
            <h6 className="mb-3">You May Also Like</h6>
            {randomProducts.map((p) => (
              <div key={p.id} className="mb-4 text-center">
                <Image src={p.img} fluid className="mb-2 rounded" onClick={() => {
                  navigate(`/productDetails/${p.id}`);
                }} />
                <div className="small you-may-also-like-title mb-1">
                  {p.title}
                </div>

                <div className="fw-semibold" style={{ color: "#7c0046" }}>₹&nbsp;{p.price}</div>

                <hr />
              </div>
            ))}
          </div>
          <div className="px-3 py-2 d-md-none">
            <h6 className="mb-3">You May Also Like</h6>
            <div
              className="d-flex overflow-x-auto pb-2 hide-scrollbar"
              style={{
                gap: "10px",
                WebkitOverflowScrolling: "touch",
              }}
            >
              {randomProducts.map((p) => (
                <div
                  key={p.id}
                  className="flex-shrink-0 text-center"
                  style={{ minWidth: "120px" }}
                >
                  <Image
                    src={p.img}
                    onClick={() => {
                      navigate(`/productDetails/${p.id}`);
                    }}
                    fluid
                    className="mb-2 rounded"
                    style={{ maxHeight: "120px", objectFit: "cover" }}
                  />
                  <div className="small">{p.title}</div>
                  <div className="fw-semibold text-danger">₹{p.price}</div>
                </div>
              ))}
            </div>
          </div>
          {/* RIGHT COLUMN - Product Quick View */}
          <div className="flex-grow-1 p-4 d-flex flex-column" style={{ overflowY: "auto", maxWidth: "70vh" }} >
            <h6 className="text-uppercase text-muted mb-2">Quick View</h6>
            <h4 className="fw-bold mb-3">
              {displayProduct?.product_name || displayProduct?.title}
            </h4>

            {/* <div className="mb-3">
              {productDetails?.special_price ? (
                <>
                  <span className="h5 fw-bold" style={{ color: "#7c0046" }}>
                    ₹{parseFloat(productDetails.special_price).toFixed(2)}
                  </span>
                  {productDetails?.mrp &&
                    parseFloat(productDetails.mrp) >
                    parseFloat(productDetails.special_price) && (
                      <del className="text-muted ms-2">
                        ₹{parseFloat(productDetails.mrp).toFixed(2)}
                      </del>
                      
                    )}
                </>
              ) : (
                // fallback if no special_price available
                <span className="h5 fw-bold" style={{ color: "#7c0046" }}>
                  ₹{parseFloat(productDetails?.mrp || displayPrice || 0).toFixed(2)}
                </span>
              )}
            </div> */}
<div className="mb-3">
      {productDetails?.special_price ? (
        <>
          <span className="h5 fw-bold" style={{ color: "#7c0046" }}>
            ₹{parseFloat(productDetails.special_price).toFixed(2)}
          </span>
          {productDetails?.mrp && parseFloat(productDetails.mrp) > parseFloat(productDetails.special_price) && (
            <>
              <del className="text-muted ms-2">
                ₹{parseFloat(productDetails.mrp).toFixed(2)}
              </del>
              <span className="text-success ms-2">
                {`(${Math.round(((productDetails.mrp - productDetails.special_price) / productDetails.mrp) * 100)}% OFF)`}
              </span>
            </>
          )}
        </>
      ) : (
        <span className="h5 fw-bold" style={{ color: "#7c0046" }}>
          ₹{parseFloat(productDetails?.mrp || displayPrice || 0).toFixed(2)}
        </span>
      )}
    </div>

            {/* Description */}
            <p className="text-muted small mb-4">
              {displayProduct?.description}
            </p>

            {/* Colors */}
            <div className="mb-3">
              <h6 className="fw-semibold mb-2">Product Details</h6>
              <div className="d-flex flex-column">
                {[
                  ["Category", productDetails?.category],
                  ["Sub-Category", productDetails?.sub_category],
                  ["Brand", productDetails?.brand],
                  ["Size", productDetails?.size],
                  ["Unit", productDetails?.unit],
                  ["Weight", productDetails?.weight],
                  ["Package Type", productDetails?.package_type],


                ].map(([label, value], idx) =>
                  value ? (
                    <div
                      key={idx}
                      className="d-flex justify-content-between py-1"
                      style={{ borderBottom: "1px solid #ccc", fontSize: "0.85rem" }}
                    >
                      <span className="">{label}</span>
                      <span>{value}</span>
                    </div>
                  ) : null
                )}
              </div>
            </div>


            <div className="mb-4">

              <div className="d-flex align-items-center border rounded-pill overflow-hidden" style={{ width: "130px", height: "40px" }}>
                {/* Minus Button */}
                <button
                  className="quick-view-qty-btn"
                  style={{
                    width: "40px",
                    height: "100%",
                    fontSize: "18px",
                    lineHeight: "1",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "none",
                    padding: "0",
                    cursor: "pointer",
                    fontWeight: "bold",
                  }}
                  onClick={decrementQuantity}
                >
                  −
                </button>

                {/* Quantity Input */}
                <input
                  type="number"
                  className="form-control text-center border-0 bg-transparent fw-bold"
                  style={{
                    width: "50px",
                    height: "100%",
                    fontSize: "16px",
                    padding: "0",
                    textAlign: "center",
                    outline: "none",
                    fontWeight: "bold",
                  }}
                  value={quantity}
                  // onChange={handleQuantityChange}
                  min="1"
                />

                {/* Plus Button */}
                <button
                  className="quick-view-qty-btn"
                  style={{
                    width: "40px",
                    height: "100%",
                    fontSize: "18px",
                    lineHeight: "1",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "none",
                    padding: "0",
                    cursor: "pointer",
                    fontWeight: "bold",
                  }}
                  onClick={incrementQuantity}
                >
                  +
                </button>
              </div>
            </div>

            {/* Buttons */}
            <div className="d-flex flex-column gap-2 mt-auto">
              {getAuthToken() ? (
                <>
                  <Button
                    style={{
                      backgroundColor: "#7c0046",
                      color: "#fff",
                    }}
                    size="sm"
                    className="w-100 rounded-pill"
                    onClick={() => handleAddToCart(productDetails)}
                  >
                    ADD TO CART &nbsp;₹&nbsp; {((parseFloat(productDetails?.special_price) || 0) * quantity).toFixed(2)}
                  </Button>

                  <Button
                    style={{
                      backgroundColor: "#124f14",
                      color: "#fff",
                    }}
                    size="sm"
                    className="w-100 rounded-pill"
                    // onClick={() => handleAddToCart(productDetails)}
                    onClick={async () => {
                      await handleAddToCart(productDetails);
                      navigate("/checkout");
                    }}
                  >
                    BUY IT NOW
                  </Button>

                  <Button
                    variant="link"
                    size="sm"
                    onClick={onHide}
                    className="mt-2"
                  >
                    OR CONTINUE SHOPPING
                  </Button>
                </>
              ) : (
                <p className="text-center text-muted">Please log in to add products to your cart.<Link to={'/login'}>Login</Link></p>
              )}
            </div>

          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ProductQuickViewModal;










